/**
 * Skogstad Sport – nedtelling til VIP-kampanjen slutter (okt. 2026)
 * ---------------------------------------------------------------------------
 * Brukes av:
 *   sections/skogstad-vip-stripe.liquid  kort:  «Slutter om 2 d 14 t 32 min»
 *   sections/skogstad-vip-steg.liquid    ledd:  2 DAGER | 14 TIMER | 32 MINUTTER
 *
 * Sluttiden kommer fra snippets/skogstad-vip-slutt.liquid (data-slutt, Unix-
 * sekunder i UTC), så alle ser samme øyeblikk uansett tidssone.
 *
 * ---------------------------------------------------------------------------
 * HVA SOM VISES
 *
 *   Mer enn ett døgn igjen  →  dager, timer, minutter
 *   Under ett døgn          →  timer, minutter
 *   Siste time              →  minutter, sekunder
 *
 * Sekundene står bare den siste timen. Før det ville de tikket hele tiden
 * uten å fortelle kunden noe nytt.
 *
 * ---------------------------------------------------------------------------
 * NÅR KLOKKA TREFFER NULL
 *
 * Nærmeste [data-sk-vip-skjul] skjules (stripa, nedtellingsraden). Det skjer
 * også hvis siden lastes etter sluttiden, f.eks. en bufret side fra Shopify –
 * det er hullet snippets/skogstad-vip-aktiv ikke kan tette, fordi Liquid bare
 * vet når siden sist ble rendret.
 *
 * Før skriptet har kjørt står tallene usynlige (klassen sk-vip-ned--venter,
 * visibility: hidden) men tar plass, så stripa øverst ikke hopper når tallene
 * kommer.
 */

(function () {
  'use strict';

  if (window.skVipNedtelling) return;
  window.skVipNedtelling = true;

  var VELGER = '[data-sk-vip-nedtelling]';
  var VENTER = 'sk-vip-ned--venter';
  var aktive = [];
  var intervall = null;

  function tosifret(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // Hvilke ledd som vises, og med hvilke tall. Rundes opp, så klokka viser
  // «1 s» det siste sekundet og når null nøyaktig når tiden er ute.
  function deler(igjenMs) {
    var s = Math.max(0, Math.ceil(igjenMs / 1000));
    var d = Math.floor(s / 86400);
    var t = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sek = s % 60;

    if (d > 0) return [['dager', d], ['timer', t], ['minutter', m]];
    if (t > 0) return [['timer', t], ['minutter', m]];
    return [['minutter', m], ['sekunder', sek]];
  }

  function Nedtelling(rot) {
    this.rot = rot;
    this.slutt = parseInt(rot.getAttribute('data-slutt'), 10) * 1000;
    this.format = rot.getAttribute('data-format') || 'kort';
    this.skjul = rot.closest('[data-sk-vip-skjul]') || rot;
    this.sist = '';

    if (isNaN(this.slutt)) {
      // Ugyldig sluttid: vis ingenting heller enn feil tall.
      rot.hidden = true;
      return;
    }

    if (this.format === 'kort') {
      var enheter = (rot.getAttribute('data-enheter') || 'd,t,min,s').split(',');
      this.enheter = {
        dager: (enheter[0] || 'd').trim(),
        timer: (enheter[1] || 't').trim(),
        minutter: (enheter[2] || 'min').trim(),
        sekunder: (enheter[3] || 's').trim()
      };
      this.felt = rot.querySelector('[data-tid]') || rot;
    } else {
      this.ledd = {};
      var li = rot.querySelectorAll('[data-ledd]');
      for (var i = 0; i < li.length; i++) {
        this.ledd[li[i].getAttribute('data-ledd')] = {
          rot: li[i],
          tall: li[i].querySelector('[data-tall]')
        };
      }
    }

    this.ferdig = false;
    this.tegn();
    aktive.push(this);
  }

  Nedtelling.prototype.tegn = function () {
    if (this.ferdig) return;

    var igjen = this.slutt - Date.now();
    if (igjen <= 0) {
      this.ferdig = true;
      this.skjul.hidden = true;
      return;
    }

    var liste = deler(igjen);

    if (this.format === 'kort') {
      var enheter = this.enheter;
      // Siste minutt: «45 s», ikke «0 min 45 s».
      if (liste.length > 1 && liste[0][1] === 0) liste = liste.slice(1);
      var tekst = liste.map(function (del) {
        var tall = del[0] === 'sekunder' ? tosifret(del[1]) : String(del[1]);
        return tall + ' ' + enheter[del[0]];
      }).join(' ');
      if (tekst !== this.sist) {
        this.felt.textContent = tekst;
        this.sist = tekst;
      }
    } else {
      var vis = {};
      for (var i = 0; i < liste.length; i++) {
        vis[liste[i][0]] = i === 0 ? String(liste[i][1]) : tosifret(liste[i][1]);
      }
      for (var navn in this.ledd) {
        if (!Object.prototype.hasOwnProperty.call(this.ledd, navn)) continue;
        var ledd = this.ledd[navn];
        var synlig = Object.prototype.hasOwnProperty.call(vis, navn);
        if (ledd.rot.hidden === synlig) ledd.rot.hidden = !synlig;
        if (synlig && ledd.tall && ledd.tall.textContent !== vis[navn]) {
          ledd.tall.textContent = vis[navn];
        }
      }
    }

    this.rot.classList.remove(VENTER);
  };

  function tegnAlle() {
    var igjen = false;
    for (var i = 0; i < aktive.length; i++) {
      aktive[i].tegn();
      if (!aktive[i].ferdig) igjen = true;
    }
    if (!igjen) stopp();
  }

  function start() {
    if (intervall || !aktive.length) return;
    intervall = window.setInterval(tegnAlle, 1000);
  }

  function stopp() {
    window.clearInterval(intervall);
    intervall = null;
  }

  function finn(omraade) {
    var noder = (omraade || document).querySelectorAll(VELGER);
    for (var i = 0; i < noder.length; i++) {
      if (noder[i].skVipNedtelling) continue;
      noder[i].skVipNedtelling = new Nedtelling(noder[i]);
    }
    start();
  }

  // En telefon som har ligget i lomma skal vise riktig tall med en gang.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stopp();
    } else {
      tegnAlle();
      start();
    }
  });

  // Temaeditoren rendrer seksjoner på nytt når innstillinger endres.
  document.addEventListener('shopify:section:load', function (e) {
    finn(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { finn(); });
  } else {
    finn();
  }
})();
